/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Warning_Chars_LabelInputs */

const en_event_warning_chars_label = /** @type {(inputs: Event_Warning_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chars`)
};

const fr_event_warning_chars_label = /** @type {(inputs: Event_Warning_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caract.`)
};

const de_event_warning_chars_label = /** @type {(inputs: Event_Warning_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charaktere`)
};

const it_event_warning_chars_label = /** @type {(inputs: Event_Warning_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caratteri`)
};

const ru_event_warning_chars_label = /** @type {(inputs: Event_Warning_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чары`)
};

const es_event_warning_chars_label = /** @type {(inputs: Event_Warning_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres`)
};

const zh_cn2_event_warning_chars_label = /** @type {(inputs: Event_Warning_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字符`)
};

const ja_event_warning_chars_label = /** @type {(inputs: Event_Warning_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文字`)
};

const hi_event_warning_chars_label = /** @type {(inputs: Event_Warning_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घर का काम`)
};

const pt_pt2_event_warning_chars_label = /** @type {(inputs: Event_Warning_Chars_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personagens`)
};

/**
* | output |
* | --- |
* | "Chars" |
*
* @param {Event_Warning_Chars_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_chars_label = /** @type {((inputs?: Event_Warning_Chars_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Chars_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_warning_chars_label(inputs)
	if (locale === "de") return de_event_warning_chars_label(inputs)
	if (locale === "it") return it_event_warning_chars_label(inputs)
	if (locale === "ru") return ru_event_warning_chars_label(inputs)
	if (locale === "es") return es_event_warning_chars_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_warning_chars_label(inputs)
	if (locale === "ja") return ja_event_warning_chars_label(inputs)
	if (locale === "hi") return hi_event_warning_chars_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_warning_chars_label(inputs)
	return en_event_warning_chars_label(inputs)
});